<button (click)="openCreateDialog($event)" class="btn btn-primary m-2 rounded-pill">{{ 'feature.playlist.create' | translate }}</button>
<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col" id="name">{{ 'common.label.title' | translate }}</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr [routerLink]="['/playlist','detail']" [queryParams]="{id: playlist.id}" *ngFor="let playlist of playlistList; index as i">
      <td>{{ i + 1 }}</td>
      <td><a [routerLink]="['/playlist','detail']" [queryParams]="{id: playlist.id}">{{ playlist.title }}</a></td>
      <td class="text-center">
        <button (click)="openEditDialog(playlist, $event)" class="btn btn-secondary m-2 btn-sm rounded-circle">
          <i class="bi bi-pencil-square"></i>
        </button>
        <button (click)="openDeleteDialog(playlist, $event)" class="btn btn-danger btn-sm m-2 rounded-circle">
          <i class="bi bi-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
